import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
  Reducer,
  UnknownAction,
} from "redux";
import { thunk } from "redux-thunk";
import { isUserAction } from "../actions/User.js";
import { adminReducer } from "../reducers/index.js";
import storeReducer from "../reducers/store.js";
import { StoreState } from "../types/index.js";

export default function configureStore(initialState: StoreState) {
  const mainReducer: Reducer<StoreState, UnknownAction> = (state, action) => {
    if (isUserAction(action) && action.type === "LOGOUT_USER") {
      state = initialState;
    }
    const adminReducerState = adminReducer(state, action);
    const storeReducerState = storeReducer(
      adminReducerState,
      action,
      initialState,
    );

    return storeReducerState;
  };

  // Setup for the Redux DevTools Extension
  // https://github.com/reduxjs/redux-devtools/tree/main/extension#11-basic-store
  const composeEnhancers =
    (typeof window !== "undefined" &&
      (
        window as unknown as {
          __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
        }
      ).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    mainReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
  );

  return store;
}
